// extracted by mini-css-extract-plugin
export default {"contentScroll":"plans-modal_contentScroll__uLjnl","salesContainer":"plans-modal_salesContainer__JCS9Q","salesBox":"plans-modal_salesBox__nc43+","images":"plans-modal_images__HxiGP"};